<template>
  <card-seplag titulo='Consultar Assunto'>
    <div class="p-grid p-col-12 p-fluid" style="align-items: flex-end">
        <Rotulo nome="Selecione tipo assunto:" cols="12 6 4">
          <Dropdown v-model="dropdown.tipoAssuntoSelecionado" :options="dropdown.tipoAssuntoList" option-label="nomeAssunto"  placeholder="Selecione uma opção..." :filter="true" @change="buscarAssuntoPorTipoAssuntoRequest()" />
        </Rotulo>
        <Rotulo nome="Selecione assunto:" cols="12 6 4">
          <Dropdown v-model="dropdown.assuntoSelecionado" :options="dropdown.assuntoList" option-label="nomeAssunto"  placeholder="Selecione uma opção..." :filter="true" />
        </Rotulo>
          <Rotulo cols="12 6 2">
          <Button label="Limpar" class="botao" @click="limpar()" />
        </Rotulo>
        <Rotulo cols="12 6 2">
          <Button label="Buscar" class="botao" @click="buscarAssuntoPorTipoAssuntoOuAssuntoRequest()" />
        </Rotulo>
      </div>
   
    <div class="p-col-12">
      <div class="p-grid p-fluid">
        <Rotulo cols="12 4">
          <Button label="Adicionar" class="botao" @click="abriModalAdicionar" />
        </Rotulo>
      </div>
    </div>
    <div class="p-col-12">
      <div class="p-grid p-fluid">
        <Rotulo nome="Assuntos cadastrados:" cols="12">
          <table-seplag :dados.sync="tabela.assuntoDTOList" :campos="tabela.camposTabela" :hasEventoAcao="true" :rows="10" :paginacao="true" :totalRegistro.sync="tabela.totalRegistro">
            <Column header="Editar" headerStyle="width: 3.vw; " bodyStyle=" ">
              <template #body="slotProps">
                <div class="p-col-12 p-md-12 p-lg-12 ">
                  <Button class="p-button-icon p-button-warning" icon="pi pi-user" @click="abriModalEditar(slotProps.data)"/>
                </div>
              </template>
            </Column>
            <Column header="Excluir" headerStyle="width: 3.vw; " bodyStyle=" ">
              <template #body="slotProps">
                <div class="p-col-12 p-md-12 p-lg-12 ">
                  <Button class="p-button-danger" icon="pi pi-times" @click="abriModalExcluir(slotProps.data)"/>
                </div>
              </template>
            </Column>
          </table-seplag>
        </Rotulo>
      </div>
    </div>
    <Dialog :header="modal.titulo" v-if="modal.exibirExcluir" :visible.sync="modal.exibirExcluir" :modal="true" :contentStyle="'min-width:30rem;min-height: 15rem;'">
      <div>
        <p>Deseja realmente excluir o assunto ?</p>
      </div>
      <div class="p-col-12">
        <div class="p-grid p-fluid">
          <Rotulo cols="12 4">
            <Button label="Não" class="botao" @click="fecharModal()" />
          </Rotulo>
          <Rotulo cols="12 4">
            <Button label="Sim" class="botao" @click="excluirAssuntoRequest()" />
          </Rotulo>
        </div>
      </div>
    </Dialog>
    <Dialog :header="modal.titulo" v-if="modal.exibirEditar" :visible.sync="modal.exibirEditar" :modal="true" :contentStyle="'min-width:30rem;min-height: 15rem;'">
      <card-seplag>
        <div class="p-col-12">
          <div class="p-grid p-fluid">
            <Rotulo nome="Assunto:" cols="12 4">
              <InputText type="text" v-model="modal.item.nomeAssunto" v-required="true"></InputText>
            </Rotulo>
            <Rotulo nome="Selecione o status:" cols="12 4">
              <Dropdown v-model="modal.item.statMostrarAssunto" :options="dropdown.statusList" placeholder="Selecione uma opção..." :filter="true" />
            </Rotulo>
          </div>
        </div>
        <div class="p-col-12">
          <div class="p-grid p-fluid">
            <Rotulo nome="Quantidade de caracteres obrigatórios:" cols="12 4">
              <InputText type="text" v-model="modal.item.numrCaracteres" v-required="true"></InputText>
            </Rotulo>
          </div>
        </div>
        <div class="p-col-12">
          <div class="p-grid p-fluid">
            <Rotulo cols="12 4">
              <Button label="Cancelar" class="botao" @click="fecharModal()" />
            </Rotulo>
            <Rotulo cols="12 4">
              <Button label="Salvar" class="botao" @click="atualizarAssuntoRequest()" />
            </Rotulo>
          </div>
        </div>
      </card-seplag>
    </Dialog>
    <Dialog 
      :header="modal.titulo" 
      v-if="modal.exibirAdicionar" 
      :visible.sync="modal.exibirAdicionar" 
      :modal="true" 
      :contentStyle="'min-width:30rem;min-height: 15rem;'"
      >
      <card-seplag>
        <div class="p-col-12">
          <div class="p-grid p-fluid">
            <Rotulo nome="Selecione tipo assunto:" cols="12 4">
              <Dropdown v-model="modal.item.assuntoPai" :options="dropdown.tipoAssuntoList" option-label="nomeAssunto"  placeholder="Selecione uma opção..." :filter="true" />
            </Rotulo>
            <Rotulo nome="Assunto:" cols="12 4">
              <InputText type="text" v-model="modal.item.nomeAssunto" v-required="true"></InputText>
            </Rotulo>
          </div>
        </div>
        <div class="p-col-12">
          <div class="p-grid p-fluid">
            <Rotulo nome="Quantidade de caracteres obrigatórios:" cols="12 4">
              <InputText type="number" v-model="modal.item.numrCaracteres" v-required="true"></InputText>
            </Rotulo>
          </div>
        </div>
        <div class="p-col-12">
          <div class="p-grid p-fluid">
            <Rotulo cols="12 4">
              <Button label="Cancelar" class="botao" @click="fecharModal()" />
            </Rotulo>
            <Rotulo cols="12 4">
              <Button label="Salvar" class="botao" @click="salvarAssuntoRequest()" />
            </Rotulo>
          </div>
        </div>
      </card-seplag>
    </Dialog>
  </card-seplag>
</template>

<script>
import {baseApiUrl} from "@/config/global";
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";

export default {
  components: {TableSeplag, Rotulo, CardSeplag},
  data: function () {
    return {
      url: {
        buscarTipoAssunto: "/assuntos/buscarTipoAssunto",
        buscarAssunto: "/assuntos/buscarAssunto",
        buscarAssuntoPorTipoAssunto: "/assuntos/buscarAssuntoPorTipoAssunto",
        buscarAssuntoPorTipoAssuntoOuAssunto: "/assuntos/buscarAssuntoPorTipoAssuntoOuAssunto",
        excluirAssunto: "/assuntos",
        salvarAssunto: "/assuntos",
        atualizarAssunto: "/assuntos"
      },
      dropdown: {
        tipoAssuntoSelecionado: null,
        tipoAssuntoList: [],
        assuntoSelecionado: null,
        assuntoList: [],
        statusList: ["ATIVO", "INATIVO"],
        statusSelecionado: null
      },
      tabela: {
        assuntoDTOList: [],
        totalRegistro: 0,
        camposTabela: [
          {nome: 'assuntoPai.nomeAssunto', titulo: 'Tipo de Assunto', tamanho: '15.vw', alinhamento: "left"},
          {nome: 'nomeAssunto', titulo: 'Assunto', tamanho: '15.vw', alinhamento: "left"},
          {nome: 'numrCaracteres', titulo: 'Caracteres', tamanho: '10.vw', alinhamento: "left"},
          {nome: 'statMostrarAssunto', titulo: 'Status', tamanho: '10.vw', alinhamento: "left"}
        ]
      },
      modal: {
        titulo: null,
        especie: null,
        exibir: false,
        item: null,
        exibirAdicionar:false,
        exibirEditar:false,
        exibirExcluir:false
      }
    }
  },
  methods: {
    async carregarDados() {
      this.buscarTipoAssuntoRequest()
      this.buscarAssuntoRequest()
    },
    removerElementoDaLista(idenAssunto) {
      let list = []
      for (let obj of this.tabela.assuntoDTOList) {
        if (obj.idenAssunto !== idenAssunto) {
          list.push(obj)
        }
      }
      this.tabela.assuntoDTOList = list
    },
    abriModalAdicionar(){
      this.modal.item ={nomeAssunto: null, numrCaracteres: null, assuntoPai: null}
      this.modal.titulo = "Adicionar assunto"
      this.modal.exibirAdicionar = true
    },
    abriModalEditar(data){
      this.modal.item = data
      this.modal.titulo = `Editar assunto: ${data.nomeAssunto}`
      this.modal.exibirEditar = true
    },
    abriModalExcluir(data){
      this.modal.item = data
      this.modal.titulo = `Excluir assunto: ${data.nomeAssunto}`
      this.modal.exibirExcluir = true
    },
  
    fecharModal() {
      this.modal.exibirExcluir = false
      this.modal.exibirEditar = false
      this.modal.exibirAdicionar = false
      this.modal.item = null
      this.modal.titulo = null
      this.modal.especie = null
    },
    buscarTipoAssuntoRequest() {
      this.$http.get(`${baseApiUrl}${this.url.buscarTipoAssunto}`).then(res => {
        this.dropdown.tipoAssuntoList = res.data.sort((a, b) => {
          if (a.nomeAssunto < b.nomeAssunto) {
            return -1;
          }
          if (a.nomeAssunto > b.nomeAssunto) {
            return 1;
          }
          return 0;
        });
      })
    },
    buscarAssuntoRequest() {
      this.$http.get(`${baseApiUrl}${this.url.buscarAssunto}`).then(res => {
        this.dropdown.assuntoList = res.data.sort((a, b) => {
          if (a.nomeAssunto < b.nomeAssunto) {
            return -1;
          }
          if (a.nomeAssunto > b.nomeAssunto) {
            return 1;
          }
          return 0;
        });
      })
    },
    buscarAssuntoPorTipoAssuntoRequest() {
      this.$http.get(`${baseApiUrl}${this.url.buscarAssuntoPorTipoAssunto}` + "/" + `${this.dropdown.tipoAssuntoSelecionado.idenAssunto}`).then(res => {
        this.dropdown.assuntoList = res.data.sort((a, b) => {
          if (a.nomeAssunto < b.nomeAssunto) {
            return -1;
          }
          if (a.nomeAssunto > b.nomeAssunto) {
            return 1;
          }
          return 0;
        });
      }).catch(() => {
        this.dropdown.assuntoList = []
      })
    },
    buscarAssuntoPorTipoAssuntoOuAssuntoRequest() {
      if (this.dropdown.tipoAssuntoSelecionado == null && this.dropdown.assuntoSelecionado == null) {
        this.$toast.add({ severity: 'error', summary: 'O tipo assunto ou assunto devem ser informados', life: 2000 })
        return
      }
      let assuntoRequest = {
        "idenAssuntoPai": this.dropdown.tipoAssuntoSelecionado != null ? this.dropdown.tipoAssuntoSelecionado.idenAssunto : null,
        "idenAssunto": this.dropdown.assuntoSelecionado != null ? this.dropdown.assuntoSelecionado.idenAssunto : null
      }
      this.$http.post(`${baseApiUrl}${this.url.buscarAssuntoPorTipoAssuntoOuAssunto}`, JSON.stringify(assuntoRequest)).then(res => {
        this.tabela.assuntoDTOList = res.data.content
      })
    },
    excluirAssuntoRequest() {
      this.$http.delete(`${baseApiUrl}${this.url.excluirAssunto}/${this.modal.item.idenAssunto}`).then(() => {
        this.$toast.add({ severity: 'success', summary: 'Assunto deletado com sucesso', life: 1000 })
        this.removerElementoDaLista(this.modal.item.idenAssunto)
        this.buscarAssuntoRequest()
        this.fecharModal()
      })
    },
    salvarAssuntoRequest() {
      if (!this.validaDadosRequest()){
        return
      }
      let assuntoRequest = {
        "nomeAssunto": this.modal.item.nomeAssunto,
        "numrCaracteres": this.modal.item.numrCaracteres,
        "idenAssuntoPai": this.modal.item.assuntoPai.idenAssunto
      }
      this.$http.post(`${baseApiUrl}${this.url.salvarAssunto}`, JSON.stringify(assuntoRequest)).then(() => {
        this.$toast.add({ severity: 'success', summary: 'Assunto cadastrado com sucesso', life: 2000 })
        this.fecharModal()
        this.buscarAssuntoRequest()
      })
    },
    atualizarAssuntoRequest() {
      if (!this.validaDadosRequest()){
        return
      }
      let assuntoRequest = {
        "nomeAssunto": this.modal.item.nomeAssunto,
        "numrCaracteres": this.modal.item.numrCaracteres,
        "statMostrarAssunto": this.modal.item.statMostrarAssunto,
        "idenAssuntoPai": this.modal.item.assuntoPai.idenAssunto
      }
      this.$http.put(`${baseApiUrl}${this.url.atualizarAssunto}/${this.modal.item.idenAssunto}`, JSON.stringify(assuntoRequest)).then(() => {
        this.$toast.add({ severity: 'success', summary: 'Assunto atualizado com sucesso', life: 2000 })
        this.fecharModal()
      })
    },
    validaDadosRequest() {
      if (this.modal.item.assuntoPai == null) {
        this.$toast.add({ severity: 'error', summary: 'O tipo assunto deve ser informado', life: 2000 })
        return false
      }
      if (this.modal.item.nomeAssunto == null) {
        this.$toast.add({ severity: 'error', summary: 'O assunto deve ser informado', life: 2000 })
        return false
      }
      if (this.modal.item.numrCaracteres == null) {
        this.$toast.add({ severity: 'error', summary: 'A quantidade de caracteres obrigatório deve ser informado', life: 2000 })
        return false
      }
      return true
    },
    limpar() {
      this.dropdown.tipoAssuntoSelecionado = null
      this.dropdown.assuntoSelecionado = null
    }
  },
  mounted() {
    this.carregarDados()
  }
}
</script>